import { Translator } from '../../types/ApiResponseTypes'
import { Commission, CommissionList } from '@/types/commission/commission'
import { CommissionItem, isCommissionListResponse } from '@/types/commission/CommissionResponse'

class CommissionResponseTranslator implements Translator<CommissionList> {
  convert(response: any): CommissionList {
    if (isCommissionListResponse(response)) {
      const commissionModels: Commission[] = response.data.commissions.map((item: CommissionItem) =>
        this.convertToCommissionModel(item),
      )

      return {
        data: {
          total: response.data.total ?? commissionModels.length,
          page: response.data.page ?? 1,
          pageSize: response.data.pageSize ?? 20,
          commissions: commissionModels,
        },
        meta: response.meta ?? {},
      }
    }
    return {
      data: {
        total: 0,
        page: 1,
        pageSize: 0,
        commissions: [],
      },
      meta: {},
    }
  }

  private convertToCommissionModel(item: CommissionItem): Commission {
    return {
      relationId: item.relationId,
      year: item.year,
      month: item.month,
      period: `${item.year}-${String(item.month).padStart(2, '0')}`,
      amount: this.formatAmount(item.amount),
    }
  }

  private formatAmount(amount: number | string): number {
    const numericAmount = typeof amount === 'number' ? amount : Number(String(amount).replace(',', '.'))

    return Number.isNaN(numericAmount) ? 0 : numericAmount
  }
}

export default new CommissionResponseTranslator()
